import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { weekendApi } from "../../../../../api/weekend";
import { HGBugsnagNotify } from "../../../../../helpers/bugsnag";

interface DeleteConfirmModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  id: number;
  refresh: () => void;
  langGroupId: number;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = (props) => {
  const { t } = useTranslation();
  const handleClose = () => props.setShow(false);

  const handleDelete = async () => {
    try {
      await weekendApi.deleteOutSchedule(props.id, props.langGroupId);
      props.refresh();
      handleClose();
    } catch (err: any) {
      console.error("wm out delete error", err);
      HGBugsnagNotify("wmOutgoingDelete", err);
    }
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("popup.confirm.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("schedules.weekend.clear-confirm")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t("popup.confirm.button.no")}
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          {t("popup.confirm.button.yes")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
